import { useCallback } from 'react';
import { useWebSocket } from './useWebSocket';

interface UseBookingWebSocketProps {
    onDataUpdate: () => void;
}

export const useBookingWebSocket = ({
    onDataUpdate,
}: UseBookingWebSocketProps) => {
    const handleBookingCreate = useCallback(
        (data: any) => {
            console.log('Booking created via WebSocket:', data);
            onDataUpdate();
        },
        [onDataUpdate]
    );

    const handleBookingUpdate = useCallback(
        (data: any) => {
            console.log('Booking updated via WebSocket:', data);
            onDataUpdate();
        },
        [onDataUpdate]
    );

    const handleConnect = useCallback(() => {
        console.log('WebSocket connected for booking updates');
    }, []);

    const handleDisconnect = useCallback(() => {
        console.log('WebSocket disconnected for booking updates');
    }, []);

    const handleError = useCallback((error: Error) => {
        console.error('WebSocket error for booking updates:', error);
    }, []);

    return useWebSocket({
        onBookingCreate: handleBookingCreate,
        onBookingUpdate: handleBookingUpdate,
        onConnect: handleConnect,
        onDisconnect: handleDisconnect,
        onError: handleError,
    });
};
